import { StencilCDNImage } from '@/components/Common/StencilImage'
import Text from '@/stories/components/Common/NewText'

const NoFilters = () => {
  return (
    <div className="flex flex-col items-center justify-center bg-white p-4">
      <StencilCDNImage
        src="https://indcdn.indmoney.com/cdn/images/fe/no-filters-l1.webp"
        alt="empty state"
        width={80}
        height={80}
      />
      <Text appearance="subtitle2" className="text-brand-grey-base py-4">
        No stocks are available currently
      </Text>
    </div>
  )
}
export default NoFilters
